import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/arrow-right.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M11.293 4.29302C11.6835 3.90249 12.3165 3.90249 12.707 4.29302L19.707 11.293C20.0976 11.6835 20.0976 12.3166 19.707 12.7071L12.707 19.7071C12.3165 20.0976 11.6835 20.0976 11.293 19.7071C10.9024 19.3166 10.9024 18.6835 11.293 18.293L16.5859 13H5C4.44772 13 4 12.5523 4 12C4 11.4478 4.44772 11 5 11H16.5859L11.293 5.70708L11.2246 5.63091C10.9043 5.23813 10.9269 4.65913 11.293 4.29302Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as ArrowRightIcon };
